module.exports = __webpack_public_path__ + "static/media/infoicon.a5db97f8.svg";